import '../styles/main.sass';
import smoothscroll from 'smoothscroll-polyfill';
import throttle from 'lodash/throttle';
import Util from './modules/Utilities';
import Sliders from './modules/Sliders';
import Header from './modules/Header';
import TabsController from './modules/TabsController';
import Search from './modules/Search';
import Menu from './modules/Menu';
import Nav from './modules/Nav';

document.addEventListener('DOMContentLoaded', () => {
  smoothscroll.polyfill();
  Util.forEachPolyfill();
  Util.anchorsInit();

  new Header(document.querySelector('.sticky-header'));
  new TabsController();
  new Search(document.querySelector('.room-search__form'));
  new Menu(document.querySelector('.menu-overlay'));
  new Nav(document.querySelector('.nav-responsive'));

  Sliders.mainSlider();
  Sliders.spaSliders();
  Sliders.facilitiesSlider();
});


//---------- Common Function: Defer Images ----------//


function imgDefer() {
  var lazyImg = document.getElementsByClassName('img-lazy');

  Array.prototype.forEach.call(lazyImg, function(el) {
    var image = new Image();
    image.setAttribute('src', el.getAttribute('data-src'));
    image.onload = function() {
      var fakeImg = this;

      el.classList.add('hide');

      setTimeout(function() {
        el.setAttribute('src', fakeImg.src);
        el.classList.remove('hide');
      }, 1000);
    }
  });
}
